

























































































































































































































































































































































































import Component, { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import { Profil } from "@/shared/Groupe";
import ErrorMixin from "@/mixins/errorMixins";
import ConfigMixin from "@/mixins/ConfigMixin";
import VueJsonToCsv from "vue-json-to-csv";
import _ from "lodash";

@Component({
  components: { VueJsonToCsv },
})
export default class Profils extends mixins(
  MobileMixin,
  ErrorMixin,
  ConfigMixin
) {
  public search: string = "";
  public selectedProfil: Profil = new Profil();
  public confirmDelete: boolean = false;
  public addGr: boolean = false;
  public editGr: boolean = false;
  public showAddSite: boolean = false;
  public showAddGr: boolean = false;
  public showExSite: boolean = false;
  public showExGr: boolean = false;

  public droits: any = [];
  public restaurantIds_to_enseigne: any = {};
  public restaurantIds_to_codeAlpha: any = {};

  public created() {
    this.resIdToCodeAlpha(this.restaurantIds_to_codeAlpha);
    this.resIdToEnseignes(this.restaurantIds_to_enseigne);
  }

  public mounted() {
    if (this.client === "TOTAL") {
      this.droits = [
        "LOGIN",
        "CONFIGURATION",
        "LIMITATION_SITE",
        "API1",
        "API2",
      ];
    } else if (
      this.global &&
      (String(this.client) !== "TOTAL")
    ) {
      this.droits = [
        "LOGIN",
        "CONFIGURATION",
        "ACCES_BASE",
        "LIMITATION_SITE",
        "RAPPORTS_ANOMALIES",
        "AUDIT",
        "FEC_CONFIGURATION",
        "RECURRENCE_CONFIGURATION",
      ];
    } else {
      this.droits = [
        "LOGIN",
        "ACCES_BASE",
        "LIMITATION_SITE",
        "RAPPORTS_ANOMALIES",
        "AUDIT",
      ];
    }
  }

  /**
   * methode de filtre des profils existants correspondant au texte entrée dans le champs de recherche
   */
  public getFilteredProfils(): Profil[] {
    let grs = new Array();
    grs = this.profils.filter(
      (profil: Profil) =>
        profil.titre.toUpperCase().includes(this.search.toUpperCase()) &&
        !profil.profileCaisse
    );
    if (grs.length === 0) {
      this.addGr = true;
    }

    grs = _.orderBy(grs, "titre");
    return grs;
  }

  public orderRS() {
    const result: any = [];
    this.selectedProfil.raisonsSociales.forEach((raisonSociale: string) => {
      result.push(raisonSociale);
    });
    this.selectedProfil.restaurantIds.forEach(
      (restaurantId: number, index: number) => {
        result[index] = { raisonSociale: result[index], restaurantId };
      }
    );
    return result;
  }

  public filteredProfilDroits() {
    return this.selectedProfil.droits.filter((droit: any) =>
      this.droits.includes(droit)
    );
  }

  public selectDroit(droit: string) {
    if (this.selectedProfil.droits.includes(droit)) {
      this.selectedProfil.droits = this.selectedProfil.droits.filter(
        (dr: any) => dr !== droit
      );
    } else {
      this.selectedProfil.droits.push(droit);
    }
  }

  public isSiteLimited() {
    return this.selectedProfil.droits.includes("LIMITATION_SITE");
  }

  /**
   * Création d'un nouveau profil au click sur entrée
   * (activé quand aucun profil de correspondant à la recherche n'est trouvé)
   */
  public onKeydown(evt: any) {
    if (evt.keyCode === 13) {
      this.selectedProfil = new Profil();
      if (this.search !== "") {
        this.selectedProfil.titre = this.search;
      }

      this.selectedProfil.$edit = true;
      this.editGr = true;
    }
  }

  /**
   * methode de selection du groupe selectionné
   */
  public selectProfil(profil: Profil) {
    this.selectedProfil = profil;
    this.selectedProfil.$edit = true;
  }

  /**
   * méthode de récupération de l'icone a afficher dans le champ de recherche
   * une loupe si on trouve des profils correspondant
   * un plus si on ne trouve pas pour proposer l'ajout
   */
  public getIcon() {
    if (this.addGr) {
      return "icon-plus";
    } else {
      return "icon-look";
    }
  }

  /**
   * Affichage d'un message de confirmation de la suppression d'un profil
   */
  public confirmDeleteProfil() {
    this.confirmDelete = true;
  }

  /**
   * methode permettant d'enregistrerv/ créer le profil selectionné
   */
  public saveProfil(profil: Profil) {
    if (profil.id !== "") {
      this.updateselectedProfil();
    } else {
      this.addProfil(profil);
    }
  }

  /**
   * méthode de suppression d"un profil
   */
  public removeProfil(profilToRem: Profil) {
    this.$store.dispatch("config/removeProfil", profilToRem).then(
      (response: any) => {
        if (response.status === 200) {
          this.selectedProfil = new Profil();
          this.confirmDelete = false;
          this.selectedProfil.$edit = false;
          this.setSuccess(
            profilToRem.titre + " " + this.$t("deleted").toString()
          );
        }
      },
      (error: any) => {
        this.setErrorFromTxt(error.toString());
      }
    );
  }

  public extract() {
    let profilsJson = new Array();
    profilsJson = this.profils.map((profil: any) => {
      return this.transformProfil(profil);
    });
    return profilsJson;
  }

  private transformProfil(profil: Profil) {
    const obj: { [k: string]: any } = {
      nom: profil.titre,
      droits: profil.droits.filter((dr: string) => this.matchingDroits(dr)),
      sites: profil.raisonsSociales,
      groupes: this.getGroupesOfUser(profil.societesPlus),
    };

    return obj;
  }

  private matchingDroits(droit: string) {
    return this.droits.indexOf(droit) !== -1;
  }

  private getGroupesOfUser(grs: any[]) {
    let groupes = "";

    grs.map((g: any) => {
      if (g.societe0 === null || g.societe0 === undefined) {
        groupes += g.raisonSociale + ", ";
      }
    });

    groupes = groupes.slice(0, -2);

    return groupes;
  }

  /**
   * methode d'ajout d'un nouveau groupe à la bdd
   */
  private addProfil(profilToAdd: Profil) {
    this.search = "";

    this.$store.dispatch("config/addProfil", profilToAdd).then(
      (response: any) => {
        // console.log(response)
        this.editGr = false;
        this.selectedProfil.$edit = false;
        this.setSuccess(profilToAdd.titre + " " + this.$t("added").toString());
      },
      (error: any) => {
        this.setErrorFromTxt(error.toString());
      }
    );
  }

  /**
   * methode de mise à jour du profil dans la bdd et dans le state de l'application
   */
  private updateselectedProfil() {
    this.$store.dispatch("config/updateOneProfil", this.selectedProfil).then(
      (response: any) => {
        // console.log(response)
        this.editGr = false;
        this.selectedProfil.$edit = false;
        this.setSuccess(
          this.selectedProfil.titre + " " + this.$t("updated").toString()
        );
      },
      (error: any) => {
        this.setErrorFromTxt(error.toString());
      }
    );
  }

  // computed
  get profils(): Profil[] {
    return this.$store.getters["config/profils"];
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
